<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1059 1076.92">
    <path
      fill="#FFF"
      d="m976.53,167.37c11.05,2.9,19.51,12.33,20.27,23.72.04.61.06,1.22.06,1.83v575.37c0,19.62-10.47,37.74-27.45,47.55l-412.45,238.13c-16.99,9.81-37.92,9.81-54.91,0l-412.45-238.13c-16.99-9.81-27.45-27.94-27.45-47.55V192.92c0-.61.02-1.23.06-1.83.76-11.39,9.22-20.82,20.26-23.72L522.26,16.51c4.56-1.2,9.34-1.2,13.9,0l440.38,150.86Z"
    />
    <path
      fill="#8E7BFF"
      d="m529.5,1076.92c-12.19,0-24.39-3.14-35.26-9.42l-412.45-238.13c-21.75-12.56-35.26-35.96-35.26-61.08V192.92c0-.96.03-1.93.1-2.88,1.18-17.69,13.71-32.74,31.26-37.61L517.74,1.55l.56-.15c7.14-1.87,14.69-1.87,21.83,0l1.1.33,439.89,150.69c17.56,4.87,30.1,19.92,31.27,37.63.06.94.1,1.91.1,2.87v575.37c0,25.12-13.51,48.52-35.27,61.08l-412.45,238.13c-10.88,6.28-23.07,9.42-35.26,9.42Zm-2.83-1045.41L86.98,182.33l-.56.15c-4.79,1.26-8.35,5.23-8.64,9.65-.02.27-.03.53-.03.8v575.37c0,13.99,7.53,27.03,19.65,34.03l412.45,238.13c12.12,7,27.17,7,39.29,0l412.45-238.13c12.12-7,19.65-20.03,19.65-34.03V192.92c0-.26,0-.52-.03-.78-.3-4.44-3.85-8.41-8.64-9.66l-1.1-.33L531.76,31.51c-1.67-.37-3.41-.37-5.09,0Z"
    />
    <line fill="#8E7BFF" stroke="#8E7BFF" stroke-width="8.4" stroke-miterlimit="10" x1="393.73" y1="815.84" x2="653.88" y2="815.84" />
    <rect fill="#8E7BFF" y="304.53" width="1059" height="179.47" rx="20.82" ry="20.82" />
    <path
      d="m340.93,157.96c-8.83,0-16.37,3.14-22.65,9.41-6.26,6.28-9.4,13.82-9.4,22.63s3.14,16.37,9.4,22.63c6.28,6.28,13.82,9.41,22.65,9.41s16.33-3.14,22.61-9.41c6.28-6.26,9.43-13.8,9.43-22.63s-3.16-16.35-9.43-22.63c-6.28-6.28-13.82-9.41-22.61-9.41Zm13.57,45.62c-3.78,3.74-8.3,5.62-13.57,5.62s-9.83-1.87-13.57-5.62c-3.76-3.76-5.63-8.28-5.63-13.57s1.87-9.81,5.63-13.57c3.74-3.78,8.26-5.67,13.57-5.67s9.79,1.89,13.57,5.67c3.78,3.76,5.65,8.3,5.65,13.57s-1.87,9.81-5.65,13.57Zm126.23-14.37l28.02-30.72h-54.54v12.63h25.86l-17.75,18.09,28.55,32.27h18.34l-28.48-32.27Zm-98.82-30.72v62.99h13.27v-26.51l19.04,25.45,19.02-25.45v26.51h13.29v-62.99l-32.31,39.81-32.31-39.81Z"
    />
    <path d="m752.38,158.48h-229.27s-5.77,0-5.77,5.77v51.46s0,5.77,5.77,5.77h229.27s5.77,0,5.77-5.77v-51.46s0-5.77-5.77-5.77Z" />
    <path
      fill="#1c1a1aff"
      d="m530.76,171.36h13.75c7.6,0,12.8,4.25,12.8,12.15,0,4.45-1.9,8.3-5.6,10.4l8,14.7h-9.65l-6.9-13h-3.8v13h-8.6v-37.24Zm13.8,16.3c2.8,0,4.2-2.1,4.2-4.15,0-2.5-1.7-4.2-4.2-4.2h-5.2v8.35h5.2Z"
    />
    <path fill="#FFF" d="m563.74,171.36h24.34v7.95h-15.8v6.6h13.35v8h-13.35v6.7h15.8v8h-24.34v-37.24Z" />
    <path fill="#FFF" d="m589.93,171.36h9.3l7.45,24.29,7.4-24.29h9.35l-12.1,37.24h-9.3l-12.1-37.24Z" />
    <path fill="#FFF" d="m627.47,171.36h8.55v37.24h-8.55v-37.24Z" />
    <path fill="#FFF" d="m642.81,171.36h24.34v7.95h-15.8v6.6h13.35v8h-13.35v6.7h15.8v8h-24.34v-37.24Z" />
    <path
      fill="#FFF"
      d="m669,171.36h9.25l5.1,22.84,4.3-18.24-1.05-4.1v-.5h10.65l5.4,22.84,5.1-22.84h9.2l-9.25,37.24h-9.4l-5.3-19.74-5.35,19.74h-9.35l-9.3-37.24Z"
    />
    <path
      fill="#FFF"
      d="m718.83,201.05l6.55-4.9c1.55,3,4.1,5.05,7.45,5.05,1.9,0,4-.75,4-3,0-1.6-1-2.35-2.5-2.85l-6.7-2.3c-5.45-1.95-8.65-5.4-8.65-10.85,0-7.1,5.45-11.45,12.55-11.45,4.8,0,9.75,2.05,12.6,7.25l-6.5,4.85c-1.25-2.55-3.35-4.1-6.1-4.1-1.85,0-4.05.8-4.05,3.15,0,1.5,1.1,2.45,2.6,2.95l6.5,2.2c5.3,1.75,8.7,5.1,8.7,10.7,0,6.15-4.8,11.45-12.89,11.45-5.35,0-10.6-2.5-13.55-8.15Z"
    />
    <text
      data-testid="badge-title"
      font-family="OMR Sans"
      font-size="115"
      font-weight="700"
      fill="#FFF"
      text-anchor="middle"
      x="529.5"
      y="440"
    >
      TOP RATED
    </text>
    <text
      data-testid="badge-text"
      font-family="OMR Sans"
      font-size="70"
      font-weight="700"
      fill="#000"
      text-anchor="middle"
      x="529.5"
      y="590"
    >
      {{ category }}
    </text>

    <text
      data-testid="badge-timeFrame"
      font-family="OMR Sans"
      font-size="60"
      font-weight="700"
      fill="#000"
      text-anchor="middle"
      x="529.5"
      y="920"
    >
      {{ timeframe }}
    </text>
  </svg>
</template>
<script setup lang="ts">
defineProps<{
  category: string
  timeframe: string
}>()
</script>
